"use strict";
// packages/contracts/src/omie.ts — Fase 04, Planos 01, 02, 03, 05, 08 e 09 (OMIE-01..06, D-01..D-16).
// Contratos seguros para a integração Omie (sem app_key/app_secret e sem payload remoto bruto).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=omie.js.map